import React, {FC, useEffect, useState} from "react";
import Link from "next/link";
import {useSelector} from "react-redux";
import {apiUrlWithStore} from "../../helper";
import {AddNewAddress, EditAddress, RemoveAddress} from "../../svg";
import {IState} from "../../types/state";
import {adressesType} from "./types";
import cls from "./account.module.scss"
import {TranslationsType} from "../../types/homePageTypes";

const AccountPageAddresses: FC<{ translationsData: TranslationsType }> = ({translationsData}) => {
    const customer = useSelector((state: IState) => state.customer);
    const [address, setAddress] = useState([]);
    const [message, setMessage] = useState("");


    useEffect(() => {
        const abortController = new AbortController();
        const signal = abortController.signal;
        if (customer.token) {
            const URL = `/api/addresses?pagination=0&token=${customer.token}`;
            fetch(URL, {signal})
                .then(response => response.json())
                .then(res => {
                    if (res.data) {
                        setAddress(res.data);
                    }
                })
                .catch((err) => console.error(err));
        }

    }, [customer.token, message]);

    const removeAddress = (event: React.MouseEvent<HTMLSpanElement, MouseEvent>, id: React.Key | null | undefined) => {
        event.preventDefault();

        if (customer.token) {
            let option = {
                method: "DELETE",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    token: customer.token,
                }),
            };
            fetch(apiUrlWithStore(`/api/addresses/${id}`), option)
                .then((responce) => responce.json())
                .then((res) => {
                    setMessage(res.message + id);
                })
                .catch((err) => console.error(err));
        }
    };

    const addresses = address?.map((address: adressesType) => (
        <React.Fragment key={address.id}>
            <div className={`${cls["addresses-list__item"]} ${cls["address-card"]}`}>
                <div className={cls["address-card__body"]}>
                    <div className={cls["address-card__name"]}>{`${address.first_name} ${address.last_name}`}</div>
                    <div className={cls["address-card__row"]}>
                        {address.country_name}
                        <br/>
                        {address.postcode}, {address.city}
                        <br/>
                        {address?.address1?.[0]}
                    </div>
                    <div className={cls["address-card__footer"]}>
                        <Link href={`/account/addresses/${address.id}`}>
                            <a>
                                <EditAddress/>
                            </a>
                        </Link>
                        &nbsp;&nbsp;
                        <span
                            className={cls["address-remove-btn"]}
                            onClick={(event) => removeAddress(event, address.id)}
                        >
                            <RemoveAddress/>
                        </span>
                    </div>
                </div>
            </div>
            {/*<div className={cls["addresses-list__divider"]}/>*/}
        </React.Fragment>
    ));

    return (
        <div className={cls["address-page-body"]}>
            <h2 className={cls["address-page-title"]}>
                {translationsData.Address}
            </h2>

            <div className={cls["addresses-list"]}>

                {addresses}

                {/*<div className={cls["addresses-list__divider"]}/>*/}

                <Link href="/account/addresses/new" style={{padding: 16}}>
                    <a className={cls.new_address_link}>
                        <span style={{display: "flex", gap: 10, flexDirection: "column", alignItems: "center"}}>
                            <AddNewAddress/>
                            {translationsData.AddNewAddress}
                        </span>
                    </a>

                </Link>
            </div>
        </div>
    );
}

export default AccountPageAddresses